import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-cycle
import KeyValue from './KeyValue';

export default function ViewObject({
	object,
	className = ''
}) {

	return (
		<div
			className={[
				'ws-tagging-ViewObject',
				'd-block',
				'p-2',
				className
			].join(' ')}
		>
			{Object.keys(object).map((key, index, array) => {
				return (
					<KeyValue
						key={key}
						dataKey={key}
						dataValue={object[key]}
						keyClasses="border-right"
						className={
							index < array.length - 1 ? 'border-bottom' : ''
						}
					/>
				);
			})}
		</div>
	);
}

ViewObject.propTypes = {
	object: PropTypes.shape({}).isRequired,
	className: PropTypes.string
};
